'use strict';

angular.module('pmtPlacesApp.directives').directive('pmtImages', [
	'$stateParams',
	'Upload',
	'$timeout',
	'$q',
	'$i18next',
	function ($stateParams, Upload, $timeout, $q, $i18next) {
		return {
			restrict: 'A',
			scope: {
				place: '=',
				done: '&',
				onClose: '&',
				showMediaDialog: '=pmtImages',
				network: '@',
				type: '@',
				multiLocation: '@',
				placeId: '@',
				facebookType: '@'
			},
			link: function (scope /*, element, attrs*/) {
				const type = scope.type;

				scope.siteName = $stateParams.site;
				scope.locations = [];

				const preselectedLocations = placeId => {
					if (placeId) {
						scope.locations = [placeId];
						return;
					}

					scope.locations = [];
				};

				function setTitle() {
					let networkName = '';
					let imageType = '';
					switch (scope.network) {
						case 'facebook':
							networkName = 'Facebook';
							imageType = scope.type;
							break;
						case 'google':
							networkName = 'Google';
							imageType = scope.type === 'profile' ? 'logo' : scope.type;
							break;
						default:
							imageType = scope.type;
							break;
					}

					switch (type) {
						case 'mediaReview':
							scope.title = $i18next.t('listings.media_upload.upload_to_network', {
								network: networkName
							});
							scope.submitButtonTitle = 'general.upload';
							break;

						default:
							scope.title = $i18next.t('listings.media_upload.title', {
								imageType: $i18next.t('general.' + imageType),
								network: networkName
							});
							break;
					}
				}

				function resetNetworkOptions() {
					scope.options = {};
					switch (scope.network) {
						case 'google':
							scope.options.mediaReview = {
								aspectRatio: 16 / 9,
								hideCropping: true,
								minFileSize: 1024 * 10,
								maxFileSize: 1024 * 5120,
								minHeight: 250,
								minWidth: 250
							};
							break;
						case 'facebook':
							scope.options.profile = {
								// min 180x180
								minWidth: 400,
								minHeight: 400,
								maxWidth: 1000,
								maxHeight: 1000,
								aspectRatio: 1 / 1,
								aspectRatioText: '1:1',
								hideCropping: true
							};

							scope.options.cover = {
								selectedOptimize: 'both',
								optimize: {
									both: {
										name: 'both', // both is a hybrid version that should work pretty well on both mobile and desktop
										icon: 'fa-solid fa-tablet-alt',
										minWidth: 400,
										minHeight: 150,
										aspectRatio: 400 / 150, // 2.66:1
										aspectRatioText: '2.66:1'
									},
									desktop: {
										name: 'desktop',
										icon: 'fa-solid fa-desktop',
										minWidth: 820,
										minHeight: 312,
										aspectRatio: 820 / 312, // 2.63:1
										aspectRatioText: '2.63:1'
									},
									mobile: {
										name: 'mobile',
										icon: 'fa-solid fa-mobile-alt',
										minWidth: 640,
										minHeight: 360,
										aspectRatio: 640 / 360, // 1.78:1
										aspectRatioText: '1.78:1'
									}
								},

								selectedPreview: 'mobile',
								previews: {
									mobile: {
										name: 'mobile',
										width: '413px', // iphone 6,7,8 screen resolution on m.facebook
										icon: 'fa-solid fa-mobile-alt',
										height: `${413 / 1.78}px`,
										objectFit: optimize => (optimize === 'desktop' ? 'cover' : 'fill')
									},
									desktop: {
										name: 'desktop',
										width: '820px', // full screen desktop
										icon: 'fa-solid fa-desktop',
										height: `${820 / 2.63}px`,
										objectFit: () => 'cover'
									}
								}
							};

							const selected = scope.options.cover.selectedOptimize;
							const largestPreview = scope.options.cover.previews.desktop;
							const { minWidth, minHeight, maxWidth, maxHeight, aspectRatio, aspectRatioText } =
								scope.options.cover.optimize[selected] || {};

							scope.options.cover = Object.assign(scope.options.cover, {
								minWidth,
								minHeight,
								maxWidth,
								maxHeight,
								aspectRatio,
								aspectRatioText,
								largestPreview
							});

							break;
						default:
							// scope.network is not set yet...
							break;
					}
				}

				resetNetworkOptions();
				scope.fillColor = '';

				const resetDirective = function () {
					scope.cropImage = false;
					scope.showUploadingProgress = false;
				};

				scope.fileSelected = function (file) {
					if (type === 'mediaReview') {
						scope.options.mediaReview.aspectRatio = file.metaData.width / file.metaData.height;
					}
					scope.cropImage = true;
					scope.workingFile = file;
				};

				scope.selectNewImage = function () {
					scope.cropImage = false;
				};

				scope.switchOptimize = (optimizationName, imageType) => {
					const { minWidth, minHeight, maxWidth, maxHeight, aspectRatio, aspectRatioText } =
						scope.options[imageType].optimize[optimizationName];

					scope.options[type] = Object.assign(scope.options[type], {
						minWidth,
						minHeight,
						maxWidth,
						maxHeight,
						aspectRatio,
						aspectRatioText
					});
				};

				let handleProgressDone = function (start) {
					return function (file) {
						let end = new Date().getTime();
						let totalTime = end - start;
						let minTimeToShow = 2000;
						let delay = 0;
						if (totalTime < minTimeToShow) {
							delay = minTimeToShow - totalTime;
						}
						$timeout(function () {
							scope.done({ file: file, locations: scope.locations }); // Tell implementer that all is done...
							scope.showMediaDialog = false;
						}, delay);
					};
				};

				const uploadImage = function (croppedBlob) {
					let deferred = $q.defer();

					const orgFileName = scope.workingFile.name;
					croppedBlob = Upload.rename(croppedBlob, 'cropped-' + orgFileName);

					Upload.upload({
						url: 'api/' + scope.siteName + '/media/' + type + '/' + scope.network,
						file: croppedBlob
					})
						.success(function (data) {
							deferred.resolve(data.data);
						})
						.error(function () {
							deferred.reject('Error uploading');
						});

					return deferred.promise;
				};

				const cropIsSameAsOriginal = cropData => {
					const workingFile = scope.workingFile;
					const croppedAspectRatio = cropData.metaData.width / cropData.metaData.height;
					const originalAspectRatio = workingFile.metaData.width / workingFile.metaData.height;

					const aspectOk = originalAspectRatio.toFixed(2) === croppedAspectRatio.toFixed(2);
					const widthSame = workingFile.metaData.width === cropData.metaData.width;
					const heightSame = workingFile.metaData.height === cropData.metaData.height;

					return aspectOk && (widthSame || heightSame);
				};

				let saveCroppedImage = function (cropData) {
					scope.showUploadingProgress = true;
					let start = new Date().getTime();

					let origMeta = scope.workingFile.metaData;
					let blobMeta = cropData.metaData;
					let promise =
						blobMeta.height !== origMeta.height || blobMeta.width !== origMeta.width
							? uploadImage(cropData.blob)
							: $q.resolve(scope.workingFile);

					return promise.then(handleProgressDone(start));
				};

				let getBlobFromCropper;
				scope.setupCropFunction = function (cb) {
					getBlobFromCropper = cb;
				};

				scope.getBlobFromCrop = function () {
					getBlobFromCropper().then(function (cropData) {
						if (cropData.disableCropping || cropIsSameAsOriginal(cropData)) {
							scope.done({ file: scope.workingFile, locations: scope.locations });
							scope.showMediaDialog = false;
						} else {
							saveCroppedImage(cropData);
						}
					});
				};

				scope.$watch('showMediaDialog', function (newVal, oldVal) {
					if (newVal !== oldVal && newVal) {
						preselectedLocations(scope.placeId);

						resetDirective();
					}
				});

				scope.$watch(
					'network',
					function (newVal /*, oldVal */) {
						if (newVal === 'facebook') {
							scope.fillColor = '#ffffff';
						}
						setTitle();
						resetNetworkOptions();
					},
					true
				);

				scope.$watch(
					'placeId',
					function (newVal /*, oldVal */) {
						scope.placeId = newVal;

						preselectedLocations(scope.placeId);
					},
					true
				);
			},
			templateUrl: 'components/fileManager/images/pmtImageView.html'
		};
	}
]);
